import script from "./SuppliersView.vue?vue&type=script&setup=true&lang=js"
export * from "./SuppliersView.vue?vue&type=script&setup=true&lang=js"

import "./SuppliersView.vue?vue&type=style&index=0&id=b96b7dfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b96b7dfe"]])

export default __exports__